import type { KlpTypographySpacing } from './IKlpStyles';

export interface SpacingDefinition {
    mobile: string;
    tablet: string;
    desktop: string;
}

export type IKlpSpacingType = keyof SpacingDefinition;

export type IKlpSpacing = {
    [spacing in KlpTypographySpacing]: SpacingDefinition;
};

export const KlpSpacing: IKlpSpacing = {
    none: {
        mobile: '0',
        tablet: '0',
        desktop: '0',
    },
    tiny: {
        mobile: '0.5rem',
        tablet: '0.5rem',
        desktop: '0.5rem',
    },
    compact: {
        mobile: '1.125rem',
        tablet: '1.125rem',
        desktop: '1.125rem',
    },
    bulky: {
        mobile: '1.5rem',
        tablet: 'auto',
        desktop: '1.66666rem',
    },
    fat: {
        mobile: '2rem',
        tablet: 'auto',
        desktop: '2.66666rem',
    },
    massive: {
        mobile: '2.66666rem',
        tablet: 'auto',
        desktop: '3.75rem',
    },
    jumbo: {
        mobile: '5.25rem',
        tablet: 'auto',
        desktop: '5.33333rem',
    },
    colossal: {
        mobile: '5.33333rem',
        tablet: 'auto',
        desktop: '7.5rem',
    },
};
